import { Heart, Lock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-secondary/50 border-t border-border py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4">
            <Logo />
            <p className="text-sm text-muted-foreground">
              Ton espace safe pour comprendre et agir face aux addictions.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Urgence</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/panic" className="hover:text-foreground transition-colors">
                  Numéros d'urgence
                </Link>
              </li>
              <li>
                <Link to="/panic" className="hover:text-foreground transition-colors">
                  Que faire en cas de crise
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Ressources</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/resources" className="hover:text-foreground transition-colors">
                  Bibliothèque RDR
                </Link>
              </li>
              <li>
                <Link to="/withdrawal" className="hover:text-foreground transition-colors">
                  Timeline de sevrage
                </Link>
              </li>
              <li>
                <Link to="/directory" className="hover:text-foreground transition-colors">
                  Annuaire CSAPA/CJC
                </Link>
              </li>
              <li>
                <Link to="/mission" className="hover:text-foreground transition-colors">
                  Notre mission
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-foreground transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">À venir</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-center gap-1.5">
                Recherche de praticiens
                <Badge variant="outline" className="text-[10px] px-1 py-0 h-4 border-accent/40 text-accent">
                  <Lock className="w-2.5 h-2.5 mr-0.5" />Bientôt
                </Badge>
              </li>
              <li className="flex items-center gap-1.5">
                Téléconsultation
                <Badge variant="outline" className="text-[10px] px-1 py-0 h-4 border-accent/40 text-accent">
                  <Lock className="w-2.5 h-2.5 mr-0.5" />Bientôt
                </Badge>
              </li>
              <li className="flex items-center gap-1.5">
                Prise de rendez-vous
                <Badge variant="outline" className="text-[10px] px-1 py-0 h-4 border-accent/40 text-accent">
                  <Lock className="w-2.5 h-2.5 mr-0.5" />Bientôt
                </Badge>
              </li>
              <li className="text-xs italic text-muted-foreground/60 mt-2">
                Recherche de financement en cours
              </li>
            </ul>
          </div>
        </div>

        {/* Legal links */}
        <div className="pt-4 border-t border-border mb-4">
          <div className="flex flex-wrap gap-4 text-xs text-muted-foreground">
            <Link to="/legal/terms" className="hover:text-foreground transition-colors">CGU</Link>
            <Link to="/legal/privacy" className="hover:text-foreground transition-colors">Confidentialité</Link>
            <Link to="/legal/cookies" className="hover:text-foreground transition-colors">Cookies</Link>
            <Link to="/legal/dpo" className="hover:text-foreground transition-colors">DPO</Link>
          </div>
        </div>

        <div className="pt-4 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © 2026 LIBR'ADDICT. Tous droits réservés.
          </p>
          <p className="text-sm text-muted-foreground flex items-center gap-2">
            Fait avec <Heart className="w-4 h-4 text-primary fill-primary" /> pour ton bien-être
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
